import { TACHI_BAR_THEME } from "./constants/chart-theme";

export const DEFAULT_BAR_PROPS = {
	labelTextColor: "var(--bs-secondary-color)",
	labelSkipHeight: 12,
	labelSkipWidth: 30,
	theme: TACHI_BAR_THEME,
	motionConfig: "stiff",
};
